var _path, _path2, _ellipse, _rect, _rect2, _ellipse2, _rect3, _rect4, _rect5, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimsNoItems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 227 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.906 191.68C182.425 191.68 225.811 148.771 225.811 95.8399C225.811 42.909 182.425 0 128.906 0C75.3861 0 32 42.909 32 95.8399C32 148.771 75.3861 191.68 128.906 191.68Z",
    fill: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.107 122.47C170.723 122.253 171.371 121.964 171.871 121.546C172.465 121.05 172.706 120.411 172.869 119.739C173.077 118.875 173.16 117.954 173.412 117.088C173.506 116.767 173.686 116.646 173.763 116.592C173.958 116.455 174.155 116.419 174.341 116.433C174.56 116.448 174.862 116.531 175.061 116.895C175.089 116.947 175.126 117.027 175.151 117.136C175.169 117.216 175.181 117.465 175.2 117.568C175.248 117.822 175.288 118.075 175.325 118.33C175.45 119.178 175.522 119.899 175.917 120.678C176.452 121.736 176.989 122.384 177.717 122.671C178.421 122.948 179.262 122.896 180.337 122.678C180.44 122.654 180.541 122.633 180.641 122.616C181.115 122.534 181.568 122.842 181.661 123.309C181.755 123.775 181.453 124.23 180.984 124.333C180.885 124.354 180.789 124.374 180.693 124.393C179.24 124.749 177.558 126.018 176.581 127.13C176.28 127.473 175.838 128.431 175.388 129.042C175.056 129.493 174.683 129.791 174.37 129.896C174.16 129.966 173.983 129.956 173.837 129.92C173.624 129.868 173.448 129.754 173.313 129.573C173.239 129.474 173.171 129.341 173.138 129.172C173.123 129.09 173.121 128.883 173.121 128.789C173.03 128.477 172.917 128.173 172.836 127.858C172.641 127.107 172.258 126.631 171.803 126.003C171.378 125.415 170.921 125.046 170.252 124.751C170.165 124.73 169.462 124.56 169.214 124.462C168.851 124.319 168.679 124.079 168.616 123.95C168.509 123.731 168.498 123.539 168.52 123.38C168.551 123.144 168.658 122.942 168.848 122.78C168.965 122.678 169.141 122.58 169.376 122.532C169.558 122.495 170.039 122.473 170.107 122.47ZM174.23 121.246C174.262 121.317 174.297 121.39 174.334 121.462C175.118 123.012 175.996 123.877 177.062 124.297L177.098 124.311C176.384 124.834 175.739 125.42 175.245 125.981C175.042 126.212 174.773 126.692 174.482 127.185C174.218 126.336 173.786 125.735 173.243 124.984C172.828 124.411 172.393 123.98 171.859 123.628C172.274 123.418 172.669 123.171 173.014 122.884C173.587 122.404 173.966 121.849 174.23 121.246Z",
    fill: "#E3E3E3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.1177,
    cy: 66.8253,
    rx: 3.20144,
    ry: 3.16624,
    fill: "#E3E3E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.5889,
    y: 47.6853,
    width: 116.365,
    height: 67.4975,
    rx: 14.1365,
    fill: "url(#paint0_linear_5378_3468)",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90.7361,
    y: 84.1998,
    width: 77.3231,
    height: 8.85213,
    rx: 4.42606,
    fill: "#CED4DA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.153,
    cy: 67.0619,
    rx: 6.53495,
    ry: 7.72312,
    fill: "#CED4DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.059082,
    y: 83.1022,
    width: 116.365,
    height: 66.659,
    rx: 14.1365,
    fill: "#CED4DA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1499,
    y: 106.051,
    width: 39.2392,
    height: 8.74216,
    rx: 4.37108,
    fill: "#04549C",
    fillOpacity: 0.44
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1499,
    y: 119.164,
    width: 77.3231,
    height: 8.74216,
    rx: 4.37108,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.9719,
    cy: 116.979,
    rx: 6.76538,
    ry: 10.9277,
    fill: "#67748E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5378_3468",
    x1: 175.583,
    y1: 273.777,
    x2: 52.3601,
    y2: 257.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2152FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21D4FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsNoItems);
export default __webpack_public_path__ + "static/media/claims-no-items.4ef7282aa56785dad7ca301dad4ffca8.svg";
export { ForwardRef as ReactComponent };